import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Input, Layout, Row, Col, Icon, Button, Table } from 'antd'

import InsuranceCalculatorRightsPopup from '@components/Popup/InsuranceCalculatorRightsPopup'
import InsuranceCalculatorParamsPopup from '@components/Popup/InsuranceCalculatorParamsPopup'

@inject((store: any) => {
    const {
        authStore,
        parametersStore,
        rightsStore,
        rightsParametersStore,
        popupStore,
        paramGroupsStore,
        rightParamSetStore,
        policiesStore,
        policyCollectionsStore,
        insuranceCalculatorStore
    } = store
    return {
        authStore,
        parametersStore,
        rightsStore,
        rightsParametersStore,
        popupStore,
        paramGroupsStore,
        rightParamSetStore,
        policiesStore,
        policyCollectionsStore,
        insuranceCalculatorStore
    }
})
@observer
export default class SimilarPolicies extends Component<any> {
    state: any = {
        similarPolicies: []
    }

    handleCheckDuplicatePolicies = async (name, id) => {
        const { insuranceCalculatorStore, popupStore, policy } = this.props
        await insuranceCalculatorStore.comparePolicies({ id: id, name: name }, { id: policy.id, name: policy.name })
        popupStore.togglePopup('insuranceCalculatorRights')
    }

    filterList = value => {
        const { policiesStore } = this.props
        this.setState({
            similarPolicies: policiesStore.similarPolicies.filter(
                policy => policy.id == value || policy.name.indexOf(value) !== -1
            )
        })
    }

    async componentDidMount() {
        await this.props.policiesStore.getSimilarPolicies({
            right_param_set_id: this.props.policy.right_param_set_id,
            policy_id: this.props.policy.id
        })
        this.setState({ similarPolicies: this.props.policiesStore.similarPolicies })
    }

    render() {
        const columns = [
            {
                title: 'מזהה',
                key: 'id',
                width: 75,
                align: 'right',
                render: (_, record) => <span>{record.id}</span>
            },
            {
                title: 'שם הפוליסה',
                key: 'name',
                width: 1000,
                align: 'right',
                render: (_, record) => <span>{record.name}</span>
            },
            {
                title: '',
                key: '',
                align: 'right',
                width: 50,
                render: (_, record) => (
                    <div>
                        <Button onClick={() => this.handleCheckDuplicatePolicies(record.name, record.id)}>
                            <Icon type="calculator" /> בדוק כפילויות
                        </Button>
                    </div>
                )
            }
        ]
        return (
            <Layout style={{ padding: '1rem', backgroundColor: 'white' }}>
                <Row>
                    <Col xs={20}>
                        <Input.Search
                            placeholder="חיפוש על פי שם הפוליסה או מזהה"
                            onChange={e => this.filterList(e.target.value)}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="box">
                            <Table
                                className="center-table"
                                style={{ width: '100%' }}
                                rowKey="id"
                                columns={columns}
                                dataSource={this.state.similarPolicies}
                            />
                        </div>
                    </Col>
                </Row>
                <InsuranceCalculatorRightsPopup />
                <InsuranceCalculatorParamsPopup />
            </Layout>
        )
    }
}
